import VuexPersistence from "vuex-persist";

export default new VuexPersistence({
    storage: window.localStorage,
    reducer: state => ({
        user: state.user,
        filter: state.filter,
        navSelection: state.navSelection,
        tabs: state.tabs,
        data: {
            pharmacies: state.data.pharmacies,
            pharmacyGroup: state.data.pharmacyGroup,
            manufacturer: state.data.manufacturer,
            pricingData: state.data.pricingData
        },
        pricingOptions: {
            referenceValue: state.pricingOptions.referenceValue,
            roundingOptions: state.pricingOptions.roundingOptions,
            roundingType: state.pricingOptions.roundingType
        }
    })
});
